import React, { useEffect, useState } from 'react'
import { AdsInfoInterface, DefaultAdsInfoInterface, ShowAdsInfoContext, modalType } from './types';
import { useDispatch } from 'react-redux';
import { getAdsInfosApi } from '../../redux/adsinfo/adsInfoApiCalls';
import DataAdsInfo from './DataAdsInfo';
import AddAdsInfoModal from './AddAdsInfoModal';
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import SuccessMsg from '../../Messages/SuccessMsg';
import EditAdsInfoModal from './EditAdsInfoModal';
import DeleteAdsInfoModal from './DeleteAdsInfoModal';
import DeletePhotoAdsInfo from './photos/DeletePhotoAdsInfo';

const ShowAdsInfo:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [showAddAdsInfoModal, setShowAddAdsInfoModal] = useState(false);
  const [showEditAdsInfoModal, setShowEditAdsInfoModal] = useState(false);
  const [showDeleteAdsInfoModal, setShowDeleteAdsInfoModal] = useState(false);
  const [selectedAdsInfo, setSelectedAdsInfo] = useState<AdsInfoInterface>(DefaultAdsInfoInterface)
  const [selectedModal, setSelectedModal] = useState("")
  const [showDeleteAdsInfoPhotoModal, setShowDeleteAdsInfoPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState("")

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getAdsInfosApi())
    }
    fetchAPIs()
  }, [dispatch])

  const navigate = useNavigate()

  return (
    <ShowAdsInfoContext.Provider value={{ 
      showSuccessMsg, setShowSuccessMsg,
      showAddAdsInfoModal, setShowAddAdsInfoModal,
      showEditAdsInfoModal, setShowEditAdsInfoModal,
      showDeleteAdsInfoModal, setShowDeleteAdsInfoModal,
      selectedAdsInfo, setSelectedAdsInfo,
      selectedModal, setSelectedModal,
      showDeleteAdsInfoPhotoModal, setShowDeleteAdsInfoPhotoModal,
      selectedPhoto, setSelectedPhoto,
    }}> 
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/>
      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded bg-main text-white" onClick={() => {
            setSelectedModal(modalType.AddModal)
            setShowAddAdsInfoModal(!showAddAdsInfoModal)
          }}>
          <FaPlus />
        </button>
      </div>
      <AddAdsInfoModal modal={showAddAdsInfoModal} toggle={() => setShowAddAdsInfoModal(!showAddAdsInfoModal)} />
      {selectedAdsInfo?.title && 
        <EditAdsInfoModal modal={showEditAdsInfoModal} toggle={() => setShowEditAdsInfoModal(!showEditAdsInfoModal)} />
      }
      {selectedAdsInfo?.title && 
        <DeleteAdsInfoModal modal={showDeleteAdsInfoModal} toggle={() => setShowDeleteAdsInfoModal(!showDeleteAdsInfoModal)} />
      }
      <DataAdsInfo />
      {
        showDeleteAdsInfoPhotoModal && 
        <DeletePhotoAdsInfo modal={showDeleteAdsInfoPhotoModal}  toggle={() => setShowDeleteAdsInfoPhotoModal(!showDeleteAdsInfoPhotoModal)}/>
      }

    </ShowAdsInfoContext.Provider>
  )
}

export default ShowAdsInfo

